/**
 * @Author: Michael Neumair <mBook>
 * @Date:   2016-09-26T10:50:29+02:00
 * @Email:  7q7w7e7r@gmail.com
 * @Last modified by:   mBook
 * @Last modified time: 2016-10-07T11:43:24+02:00
 */


import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import MPositionFormChildrenCheckout from './../components/MPositionFormChildrenCheckout';
import ALinkColor from 'common/links/components/ALinkColor';
import MFieldsetCheckout from 'common/forms/components/MFieldsetCheckout';
import MColumnsForm from 'common/forms/components/MColumnsForm';
import AInputRadioSelect from 'common/inputs/components/AInputRadioSelect';
import MInputGroupRadioSelect from 'common/inputs/components/MInputGroupRadioSelect';
import OInputFieldText from 'common/inputs/containers/OInputFieldText';
import OInputFieldDate from 'common/inputs/containers/OInputFieldDate';
import OInputFieldGroup from 'common/inputs/containers/OInputFieldGroup';
import OInputFieldAddress from 'common/inputs/containers/OInputFieldAddress';
import OInputFieldCheckbox from 'common/inputs/containers/OInputFieldCheckbox';

import {
  isEmail,
  hasToBeTrue,
  maxLength,
  requireString,
  requireDate,
  requireStringWithFormat,
} from './../../common/inputs/containers/validators';

import {MALE, FEMALE} from './../constants/genderValues';
import {i18nInterface} from 'utilities/i18n_common';
import getConstants, {isKfx} from '../../config/constants.common';
import OInputFieldNationality from '../../common/inputs/containers/OInputFieldNationality';
import {isValidNationality} from '../../utilities/nationalities';
import {isReenterEmailRequired} from '../../utilities/globalSettings';
const {DATE_OF_BIRTH_MIN_AGE, DATE_OF_BIRTH_MIN_DATE} = getConstants();

/**
 * called from react-redux connect() on a redux store update
 *
 * @param {object} state
 * @param {object} ownProps
 * @return {object}
 */
function mapStateToProps(state, ownProps) {
  if (state.checkout.formHandling.contractState ===
    'not_completed_reservation') {
    return {
      noChangesAllowed: true,
      email: state.checkout.firstTenant.email,
    };
  } else {
    return {
      noChangesAllowed: false,
      email: state.checkout.firstTenant.email,
    };
  }
}

/**
 * OFormCheckoutTenant - …
 **/
class OFormCheckoutTenant extends Component {
  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  componentDidMount() {
    const {applyFormFilterKeys} = this.props;
    applyFormFilterKeys();
  }

  /**
   * TODO jsdoc
   *
   * @return {object}
   */
  render() {
    const {
      formModel,
      helpLabel,
      helpIcon,
      onPressHelp,
      showErrors,
      isSingleTenant,
      noChangesAllowed,
      isNationalityMandatory,
      email,
    } = this.props;


    /* eslint-disable max-len */
    const personFieldsetEl = (
      <MFieldsetCheckout
        legend={i18nInterface('headlines.fieldset.personal_data')}
      >
        <MPositionFormChildrenCheckout>
          <OInputFieldGroup
            model={`${formModel}.firstTenant.gender`}
            component={MInputGroupRadioSelect}
            label={i18nInterface('label.title')}
            validators={{required: requireString}}
            messages={{required: i18nInterface('error.missing.tenant.gender')}}
            showErrors={showErrors}
            style={noChangesAllowed ? {opacity: 0.4} : {}}
          >
            <AInputRadioSelect
              htmlValue={MALE}
              onPress={noChangesAllowed ? (event) => {
                event.stopPropagation();
                event.preventDefault();
              } : null}
            >
              {i18nInterface('label.titleValues.male')}
            </AInputRadioSelect>
            <AInputRadioSelect
              htmlValue={FEMALE}
              onPress={noChangesAllowed ? (event) => {
                event.stopPropagation();
                event.preventDefault();
              } : null}
            >
              {i18nInterface('label.titleValues.female')}
            </AInputRadioSelect>
          </OInputFieldGroup>
          <MColumnsForm>
            <OInputFieldText
              model={`${formModel}.firstTenant.firstName`}
              label={i18nInterface('label.firstName')}
              validators={{
                required: requireString,
                maxLength: maxLength.bind(null, 30),
              }}
              messages={{
                required: i18nInterface('error.missing.tenant.firstName'),
                maxLength: i18nInterface('error.length.max30'),
            }}
              placeholder={'Max'}
              showErrors={showErrors}
              disabled={noChangesAllowed}
            />
            <OInputFieldText
              model={`${formModel}.firstTenant.lastName`}
              label={i18nInterface('label.lastName')}
              validators={{
                required: requireString,
                maxLength: maxLength.bind(null, 30),
              }}
              messages={{
                required: i18nInterface('error.missing.tenant.lastName'),
                maxLength: i18nInterface('error.length.max30'),
              }}
              placeholder={'Mustermann'}
              showErrors={showErrors}
              disabled={noChangesAllowed}
            />
          </MColumnsForm>
          <OInputFieldDate
            model={`${formModel}.firstTenant.birthdayDate`}
            label={i18nInterface('label.birthday')}
            placeholder={'15.01.1980'}
            validators={{
              required: requireDate,
              isLegalAge: (value) => {
                const today = new Date();
                const minDateOfBirth = new Date(
                    today.getFullYear() - DATE_OF_BIRTH_MIN_AGE,
                    today.getMonth(),
                    today.getDate()
                );
                return value <= minDateOfBirth;
              },
              isTooOld: (value) => {
                return value >= DATE_OF_BIRTH_MIN_DATE;
              },
            }}
            messages={{
              required: i18nInterface('error.missing.tenant.birthDate'),
              isLegalAge: i18nInterface('error.custom.tenant.birthDate.isLegalAge'),
              isTooOld: i18nInterface('error.custom.tenant.birthDate.isTooOld'),
            }}
            showErrors={showErrors}
            startWithYears={true}
            pickerFallbackDate={moment().subtract(28, 'years').month(0).date(1).toDate()}
            disabled={noChangesAllowed}
          />
          {!isNationalityMandatory ? null :
            (<OInputFieldNationality
              model={`${formModel}.firstTenant.nationality`}
              label={i18nInterface('label.nationality')}
              validators={{choice: isValidNationality}}
              messages={{choice: i18nInterface('error.custom.tenant.nationality')}}
              showErrors={showErrors}
              disabled={noChangesAllowed}
            />)
          }
        </MPositionFormChildrenCheckout>
      </MFieldsetCheckout>
    );
    /* eslint-enable max-len */

    /* eslint-disable max-len */
    const contactFieldsetEl = (
      <MFieldsetCheckout
        legend={i18nInterface('headlines.fieldset.personal_contact')}
      >
        <MPositionFormChildrenCheckout>
          <OInputFieldText
            model={`${formModel}.firstTenant.email`}
            label={i18nInterface('label.email')}
            placeholder={'max.mustermann@web.de'}
            validators={{
              required: requireString,
              isEmail,
              maxLength: maxLength.bind(null, 50),
            }}
            messages={{
              required: i18nInterface('error.missing.tenant.email'),
              isEmail: i18nInterface('error.format.tenant.email'),
              maxLength: i18nInterface('error.length.max50'),
            }}
            showErrors={showErrors}
            disabled={noChangesAllowed}
          />
          {isReenterEmailRequired() ?
            <OInputFieldText
              model={`${formModel}.firstTenant.email_reentered`}
              label={i18nInterface('label.email_reentered')}
              validators={{
                required: requireString,
                reEntered: (duplicateEmail) => duplicateEmail === null || duplicateEmail === '' || duplicateEmail === email,
                maxLength: maxLength.bind(null, 50),
              }}
              messages={{
                required: i18nInterface('error.missing.tenant.email'),
                reEntered: i18nInterface('error.format.tenant.email_reentered'),
                maxLength: i18nInterface('error.length.max50'),
              }}
              showErrors={showErrors}
              disabled={noChangesAllowed}
              onPaste={(e) => {
                e.preventDefault();
                e.nativeEvent.stopImmediatePropagation();
              }}
            />
          : null
          }
          <OInputFieldText
            model={`${formModel}.firstTenant.phone`}
            label={i18nInterface('label.phone')}
            placeholder={'015201234567'}
            validators={{
              required: requireString,
              format: requireStringWithFormat.bind(null, /^(\+[0-9]{1,2}|0[0-9]{2,4})[0-9]+$/),
              maxLength: maxLength.bind(null, 22),
            }}
            messages={{
              required: i18nInterface('error.missing.tenant.phone'),
              format: i18nInterface('error.format.tenant.phone'),
              maxLength: i18nInterface('error.length.max22'),
            }}
            showErrors={showErrors}
            disabled={noChangesAllowed}
          />
        </MPositionFormChildrenCheckout>
      </MFieldsetCheckout>
    );
    /* eslint-enable max-len */

    /* eslint-disable max-len */
    const addressFieldsetEl = (
      <MFieldsetCheckout
        legend={i18nInterface('headlines.fieldset.personal_current_address')}
        description={i18nInterface('label.tenant.address_description')}
        {...this.getHelpToolProperties('firstTenant.address')}
      >
        <OInputFieldAddress
          useAutocomplete={true}
          optionalAutocomplete={true}
          model={`${formModel}.firstTenant.address`}
          validators={{
            required: requireString,
          }}
          validateOn={'blur'}
          showErrors={showErrors}
          disabled={noChangesAllowed}
        />
      </MFieldsetCheckout>
    );
    /* eslint-enable max-len */

    /* eslint-disable max-len */
    const legalFieldsetEl = this.getLegalFieldset(isSingleTenant);
    /* eslint-enable max-len */

    return (
      <div className="o-form o-form-checkout-first-tenant">
        <MPositionFormChildrenCheckout>
          {personFieldsetEl}
          {contactFieldsetEl}
          {addressFieldsetEl}
          {isKfx() ? legalFieldsetEl : null}
        </MPositionFormChildrenCheckout>
      </div>
    );
  }

  // eslint-disable-next-line require-jsdoc
  getLegalFieldset() {
    const isSingleTenant = false;
    const {onPressHelp, formModel, showErrors, noChangesAllowed} = this.props;
    const creditCheckLabel = [
      <span
        key="1">{i18nInterface('label.tenant.agree.first')}
        {`${isSingleTenant ? '' : i18nInterface('label.tenant.agree.optional')}`}
        {i18nInterface('label.tenant.agree.middle')}
      </span>,
      <ALinkColor
        key="4"
        hasTooltip={true}
        onPress={
          (event) => {
            return onPressHelp('bonity_policy#2', event, true);
          }
        } // eslint-disable-line react/jsx-no-bind
      >
        {i18nInterface('label.tenant.agree.check')}
      </ALinkColor>,
      <span key="5">{i18nInterface('label.tenant.agree.end')}</span>,
    ];

    const legalFieldsetEl = (
      <MFieldsetCheckout
        legend={i18nInterface('headlines.fieldset.personal_consent')}
      >
        <OInputFieldCheckbox
          model={`${formModel}.firstTenant.isCreditCheckApproved`}
          validators={{hasToBeTrue}}
          messages={{hasToBeTrue: i18nInterface('error.missing.tenant.isCreditCheckApproved')}}
          showErrors={showErrors}
          disabled={noChangesAllowed}
        >
          {creditCheckLabel}
        </OInputFieldCheckbox>
      </MFieldsetCheckout>
    );
    return legalFieldsetEl;
  }

  /**
   *
   * @param {string} helpId
   * @return {null|{onPressTool: (function(*=): *), toolIcon, toolLabel}}
   */
  getHelpToolProperties(helpId) {
    const {
      helpLabel,
      helpIcon,
    } = this.props;

    const help = i18nInterface(helpId);
    if (typeof help == 'string' && help === '') {
      return null;
    }

    return {
      toolLabel: helpLabel,
      toolIcon: helpIcon,
      onPressTool: (e) => this.props.onPressHelp(helpId, e),
    };
  }
}

OFormCheckoutTenant.propTypes = {
  /**
   * model of the form
   */
  formModel: PropTypes.string.isRequired,
  /**
   * label of help button
   */
  helpLabel: PropTypes.string.isRequired,
  /**
   * icon of help button
   */
  helpIcon: PropTypes.string.isRequired,
  /**
   * show errors for input fields on ...
   * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
   */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
   * request help for a model
   * passes the model for which help is requested
   */
  onPressHelp: PropTypes.func,
  /*
   * is single tenant
   */
  isSingleTenant: PropTypes.bool,
  /**
   * Disable all form inputs this a readonly form then
   */
  noChangesAllowed: PropTypes.bool,
  /**
   * Disable all form inputs this a readonly form then
   */
  isNationalityMandatory: PropTypes.bool,
  /**
   * extends an already mounted mask (OFormCheckout* container components)
   * see custom reducer and applyFormFilterKeys() method
   */
  activeMaskMerge: PropTypes.bool,
};
OFormCheckoutTenant.defaultProps = {
  helpLabel: i18nInterface('label.help'),
  helpIcon: i18nInterface('label.helpIcon'),
  showErrors: true,
  isSingleTenant: true,
  noChangesAllowed: false,
  activeMaskMerge: false,
  isNationalityMandatory: false,
};

export default connect(
    mapStateToProps,
    (dispatch, ownProps) => {
      const {
        formModel,
        activeMaskMerge,
      } = ownProps;
      return {
        applyFormFilterKeys: () => {
          const activeMask = [
            `${formModel}.firstTenant.gender`,
            `${formModel}.firstTenant.firstName`,
            `${formModel}.firstTenant.lastName`,
            `${formModel}.firstTenant.email`,
            `${formModel}.firstTenant.phone`,
            `${formModel}.firstTenant.address.`,
            `${formModel}.firstTenant.birthdayDate`,
            `${formModel}.firstTenant.nationality`,
            `${formModel}.billing.partner_code`,
          ];

          if (isKfx()) {
            activeMask.push(`${formModel}.firstTenant.isCreditCheckApproved`);
            activeMask.push(`${formModel}.billing.partner_code`);
            activeMask.push(`${formModel}.objective.deposit`);
          }

          dispatch({
            type: 'HAS_ACTIVE_MASK_FOR',
            activeMask: activeMask,
            activeMaskMerge: activeMaskMerge,
          });
        },
      };
    },
)(OFormCheckoutTenant);

